import { generatePath } from 'react-router-dom'
import { LEARNINGS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { ArrowUpRightSquareContained } from 'blaze-ui/icons/20'

interface Props {
  workspaceId: number
  onPress: () => void
}

export const NavMenuLearningsItem = ({ workspaceId, onPress }: Props) => {
  const to = generatePath(LEARNINGS_PATH, { workspaceId })

  return (
    <NavMenuItem
      icon={ArrowUpRightSquareContained}
      activeIcon={ArrowUpRightSquareContained}
      to={to}
      onPress={onPress}
      label="Learnings"
    />
  )
}
